import { SignIn } from '@clerk/clerk-react';

export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-green-50 to-slate-100">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-green-600 shadow-lg">
            <span className="text-xl font-bold text-white">FC</span>
          </div>
          <h1 className="text-3xl font-bold text-slate-900">FamilyChef</h1>
          <p className="mt-1 text-sm text-slate-500">Administration</p>
        </div>

        <SignIn routing="hash" forceRedirectUrl="/" />

        <p className="mt-6 text-center text-xs text-slate-400">
          Accès réservé aux administrateurs FamilyChef
        </p>
      </div>
    </div>
  );
}
